<template>
  <div class="supplyAgreement-container">
    <article>
      <section>
        <div>甲方：{{ agreementInfo.qualificationName }}</div>
        <div>地址：{{ agreementInfo.partyaAddress }}</div>
        <div>联系人：{{ agreementInfo.partyaContract }}</div>
        <div>联系电话：{{ agreementInfo.partyaMobileNo }}</div>
        <div>联系邮箱：{{ agreementInfo.partyaEmail }}</div>
      </section>
      <section>
        <div>乙方：{{ agreementInfo.partybName }}</div>
        <div>地址：{{ agreementInfo.partybAddress }}</div>
        <div>联系人：{{ agreementInfo.partybContract }}</div>
        <div>联系电话：{{ agreementInfo.partybMobileNo }}</div>
        <div>联系邮箱：{{ agreementInfo.partybEmail }}</div>
      </section>
      <section>
        鉴于甲、乙双方签署的编号为【{{ agreementInfo.coopNumber }}】 《美团充电宝合作协议》（下称“原协议”）。现甲、乙双方在原协议的基础上达成如下补充协议：
      </section>
      <section
        v-for="(item, i) in list"
        :key="i"
        :class="{ bolder: item.bolder }"
      >
        {{ item.text }}
      </section>
      <section>
        <div>甲方：{{ agreementInfo.qualificationName }}</div>
        <div>签署日期：{{ agreementInfo.todayDate }}</div>
      </section>
      <section>
        <div>乙方：{{ agreementInfo.partybName }}</div>
        <div>签署日期：{{ agreementInfo.todayDate }}</div>
      </section>
    </article>
  </div>
</template>

<script>
import AgreementApi from '@/api/agreement';
import STATUS from '@/constants/status';

export default {
  name: 'SupplyAgreement',

  data() {
    return {
      list: [
        {
          text: '1. 将原协议合作费用条款中“甲乙双方按照智能充电设备的月度成功订单收益进行分成结算”更改为“甲乙双方按照智能充电设备的净营收进行分成结算（“净营收”即成功订单交易额扣除乙方各项成本费用后，用以计算甲方分成的基础）”，该条款中其他内容不变，仍以原协议约定为准。',
          bolder: true,
        },
        {
          text: '2. 本协议作为原协议的变更，本协议未约定的以原协议的约定为准。',
        },
        {
          text: '3. 本协议一式二份，甲、乙双方各执一份，具有同等法律效力，自加盖公章或合同章后生效。',
        },
      ],
      agreementInfo: {},
    };
  },
  async created() {
    document.body.style.background = '#FFF';
    this.getData();
  },
  methods: {
    async getData() {
      this.$store.commit('setLoading', true);
      await this.getAdditionalDetail();
      this.$store.commit('setLoading', false);
    },
    async getAdditionalDetail() {
      const partnerId = this.$store.getters['partnerModule/id'];
      const { data, respCode } = await AgreementApi.getAdditionalDetail({
        partnerId,
      });
      if (respCode === STATUS.SUCCESS) {
        this.agreementInfo = data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.supplyAgreement-container {
  padding: 30px 36px;
  font-family: PingFang SC;
  font-size: 30px;
  color: rgba(0,0,0,0.84);
  letter-spacing: 0;
  text-align: justify;
  line-height: 45px;
  article {
    .bolder {
      font-weight: 600;
    }
    section:not(:last-of-type) {
      margin-bottom: 30px;
    }
  }
}
</style>
